import { H1 } from 'platform-components';
import { withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { compose } from 'redux';

import ChangesNotification from 'common.components/changes-notification/changes-notification';
import { TeacherHeader } from 'common.components/TeacherHeader/TeacherHeader';
import PageContentTitle from 'common.components/page-content-title/page-content-title';
import { getSavedOrFirstTeamId } from 'common.components/user/selectors';
import { subjectPropType } from 'utils/data-prop-types';

import Empty from './__empty/class-lessons__empty';

import './class-lessons.scss';

export class ClassLessons extends React.Component {
    static propTypes = {
        savedOrFirstTeamId: PropTypes.number,
        getRouterPath: PropTypes.func.isRequired,
        subjects: PropTypes.arrayOf(subjectPropType),
        location: PropTypes.object.isRequired,
    };

    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    render() {
        const {
            savedOrFirstTeamId,
            getRouterPath,
            location: { search },
        } = this.props;
        const { staticUrls } = this.context;

        if (savedOrFirstTeamId) {
            return (
                <Redirect
                    to={`${getRouterPath(staticUrls.labClassLessons, { classId: savedOrFirstTeamId })}${search}`}
                />
            ); // для мэш нужен query
        }

        return (
            <>
                <TeacherHeader />
                <ChangesNotification />
                <div className="class-lessons">
                    <PageContentTitle title={<H1 id="courseView.header" />} />
                    <Empty />
                </div>
            </>
        );
    }
}

const mapStateToProps = (storeState) => ({
    savedOrFirstTeamId: getSavedOrFirstTeamId(storeState),
});

export default compose(withRouterPath, connect(mapStateToProps))(ClassLessons);
